import React, { Component } from 'react';
import ContentLoader, { Rect } from 'react-content-loader';
import { Link } from 'react-router-dom';
import { observer, inject } from 'mobx-react';
import ScrollArea from 'react-scrollbar';
import Loader from './Loader';
import NoResults from './NoResults';

@inject('NotificationStore') @observer
export default class NewContentNotices extends Component {
  urlNotification(notification) {
    const params = JSON.parse(notification.params);
    const { match } = this.props;

    switch (notification.action) {
      case 'post_store':
        return `/novidades/ver/${params.post_slug}`;
        break;
      case 'answer_store':
        //return `/home/faqs/${params.section_id}/respostas`;
        return `${match.url}/faqs/${params.section_id}/respostas`;
        break;
      case 'question_store': case 'question_general_store':
        return `${match.url}/faqs/${params.section_id}/perguntas`;
        break;
      case 'product_content_store': case 'product_content_update':
        return `/p/${params.section_slug}/${params.product_slug}/itens/${params.product_content_category_id}`;
        break;
      case 'product_store': case 'product_update':
        return `/p/${params.section_slug}/${params.product_slug}`;
        break;
      case 'faq_store': case 'faq_general':
        return `${match.url}/faqs/${params.section_id}/faq`;
        break;
      case 'document_store':
        return `/material-de-apoio/ver/${params.document_slug}`;
        break;
      case 'sale_content_store': case 'sale_content_update':
        return `/ofertas-e-combos/${params.sale_slug}/itens/${params.sales_content_category_id}`;
        break;
      case 'sale_store': case 'sale_update':
        return `/ofertas-e-combos/${params.sale_slug}`;
        break;
      default:
        return '/';
    }
  }

  componentWillMount() {
    const { NotificationStore, category } = this.props;
    NotificationStore.fetchData();
    setTimeout(() => NotificationStore.readNotifications(category), 2000);
  }


  render() {
    const { NotificationStore, category } = this.props;
    const notices = (category === 'new_content_important') ? NotificationStore.newContentImportantNotifications : NotificationStore.newContentNotifications;
    const noResultsText = (category === 'new_content_important') ? 'Não há notificações importantes no momento' : 'Não há notificações de conteúdo novo no momento';
    return (
      <ScrollArea style={{ height: 400 }} stopScrollPropagation={true}>
        {!NotificationStore.loaded && <Loader />}

        {NotificationStore.loaded &&
          !notices.length &&
          <NoResults text={noResultsText} />}
        <ul className="notice-list">
          {notices.map(notification => {
            return (
              <li key={notification.id}>
                <Link to={this.urlNotification(notification)} className={notification.read == 0 ? 'unread' : ''}>
                  <div className="notice-wrapper">
                    <img src={require('../../img/icon-notification-green.svg')} className="icon" alt="" />
                    <div className="notice-content">
                      <p>
                        <span dangerouslySetInnerHTML={{
                          __html: notification.message.replace(/(.*?)\*(.*?)\*(.*?)/g, "$1<strong>$2</strong>$3")
                        }}></span>
                      </p>
                    </div>
                  </div>
                </Link>
              </li>
            )
          })}
        </ul>
      </ScrollArea>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/notices/NewContentNotices.js